import { 
  ArrowsRightLeftIcon,
  Bars3Icon,
  CheckCircleIcon,
  XCircleIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/24/outline";

const ScheduledPaymentStatusTransformer = ({ status }) => {

    if (status === 'QUEUED') {
        return (
            <span><Bars3Icon className="h-4 w-4 text-gray-700 inline -mt-0.5"/> Queued</span>
        );
    }

    if (status === 'IN_PROGRESS') {
        return (
            <span><ArrowsRightLeftIcon className="h-4 w-4 text-blue-700 inline -mt-0.5"/> In Progress</span>
        );
    }

    if (status === 'FAILED') {
        return (
            <span><XCircleIcon className="h-4 w-4 text-red-700 inline -mt-0.5"/> Failed</span>
        );
    }

    if (status === 'COMPLETE') {
        return (
            <span><CheckCircleIcon className="h-4 w-4 text-green-700 inline -mt-0.5"/> Complete</span>
        );
    }

    if (status === 'AWAITING_APPROVAL') {
        return (
            <span><PaperAirplaneIcon className="h-4 w-4 text-gray-700 inline -mt-0.5"/> Awaiting Approval</span>
        );
    }

    return (
        <span className="text-secondary">{ status }</span>
    );
};

export default ScheduledPaymentStatusTransformer;
